import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  hasConsentPdfScalarAnswer,
  shouldShowConsentPdfNotAnswered
} from 'src/app/core/api/consent-form.util';
import { FormFieldConfig, TextConfig } from './../../../form-template-model';
import { FormTemplateGeneratorService } from './../../form-template-generator.service';

@Component({
  selector: 'csi-form-template-text-field-generator',
  templateUrl: './form-template-text-field-generator.component.html',
  styleUrls: ['./form-template-text-field-generator.component.css']
})
export class FormTemplateTextFieldGeneratorComponent implements OnInit {
  @Input() config: FormFieldConfig & { typeConfig: TextConfig };
  @Input() control: FormControl;
  @Input() formTemplateFieldKey: string;
  @Input() readOnly: boolean;
  @Input() formatForPDF: boolean;
  @Input() isConsentForm: boolean = false;
  @Input() supportingFields: { [key: string]: FormFieldConfig };

  /** Consent PDF: show when optional question was left blank. */
  public showNotAnswered = false;

  constructor(public formTemplateGeneratorService: FormTemplateGeneratorService) {}

  ngOnInit() {
    this.showNotAnswered = shouldShowConsentPdfNotAnswered(
      this.isConsentForm,
      this.formatForPDF,
      hasConsentPdfScalarAnswer(this.control && this.control.value)
    );
  }
}
